import { LinkedAnalogues } from '~/components/wiki/lithostrat/LinkedAnalogues';
import { useGroupDetailOutletContext } from '~/routes/wiki/regional/lithostrat/group.$groupId';

export default function LithostratGroupExamplesRoute() {
  const { group } = useGroupDetailOutletContext();
  return <LinkedAnalogues analogues={group.outcropLinkAnalogues} />;
}
